<template>
    <div class="playlist-pg">
        <section class="left-content" v-if="characterPlaylistId">
            <header class="all-100 align-left ">
                <h1>
                    <a class="logo push-left" href="https://estrelasemcasa.foxtv.pt/" target="_blank">FOX</a>
                </h1>
            </header>
            <div class="column-group block-character-result align-right">
                <div class="all-50 small-100 tiny-100 block-character-description">
                    <h2 class="title-negan">
                        {{ playlistData[characterPlaylistId].title }}<br />
                        <span class="white">{{playlistData[characterPlaylistId].title2}}</span>
                    </h2>
                    <h4>{{ playlistData[characterPlaylistId].h4 }}</h4>
                    <p>{{ playlistData[characterPlaylistId].p }}</p>
                    <a href="#playlist">Ouve a tua playlist &rsaquo;</a>
                </div>
                <div class="all-50 small-100 tiny-100">
                    <img class="object-fit_fill" :src="require('@/assets/'+ playlistData[characterPlaylistId].img + '.png')"/>
                </div>
            </div>
        </section>
        <section class="right-content block-playlist playlist" id="playlist">
            <div class="column-group quarter-gutters">
                <div class="all-70 tiny-100 small-100 align-left playlist-title">
                    <h4>{{ playlistData[characterPlaylistId].playlistTitle }}</h4>
                </div>
            </div>
            <div class="column-group quarter-gutters half-bottom-space">
                <div class="all-50 tiny-60 align-left">
                    <a id="spotify" class="push-left ink-button ouvir-spotify" :href="openSpotifyUrl" target="_blank" data-trackerlink="Geral|Content|Button_ListenOnSpotify">
                        <span>Abrir no </span>Spotify
                    </a>
                </div>
                <div class="all-50 tiny-40 align-right">
                    <a :href="shareFacebookUrl" data-trackerlink="Geral|Content|Button_social_facebook" id="facebook" class="facebook" target="_blank" ><i class="fa fa-facebook" aria-hidden="true"></i></a>
                    <a :href="shareTwitterUrl" data-trackerlink="Geral|Content|Button_social_twitter" id="twitter" class="twitter" target="_blank" ><i class="fa fa-twitter" aria-hidden="true"></i></a>
                </div>
            </div>
            <div class="column-group half-gutters playlist-container">
                <TrackItem 
                    :selectedTrackId="selectedTrackId" 
                    :track="track" v-for="track in tracks" :key="track.id" 
                    @onClickTrack="setActiveTrack($event)">
                </TrackItem>
            </div>
        </section>
        <footer class="column-group">
            <div class="all-100 ">
                <router-link :to="'/'">
                    <button id="create" class="push-center;">
                        Começar novo quiz
                    </button>
                </router-link>
            </div>
        </footer>
    </div>
</template>

<script>
import appConfig from "@/app.config";
import SpotifyService from "@/services/spotify.service";
import UtilService from "@/services/util.service";
import AnalyticsService from '@/services/analytics.service';

export default {
    name: "Playlist",
    data() {
        return {
            playlist: null,
            tracks: [],
            shareFacebookUrl: null,
            shareTwitterUrl: null,
            openSpotifyUrl: null,
            playlistData: appConfig.playlistData,
            characterPlaylist: null,
            selectedTrackId: null,
            isAuthenticated: SpotifyService.isAuthenticated()
        };
    },
    created() {
        AnalyticsService.pageView();
        debugger;
        this.characterPlaylist = this.$route.params.characterPlaylist;
        this.characterPlaylistId = appConfig.playlists[this.characterPlaylist];
        let userId = this.$route.params.user;
        let userPlaylistId = this.$route.params.userPlaylistId;

        if (userId && userPlaylistId) {
            this.getExistingPlaylist(userId, userPlaylistId);
        } else if (this.characterPlaylistId) {
            this.generateFinalPlaylist();
        } else {
            this.goToHome();
        }
    },
    methods: {
        getExistingPlaylist(userId, playlistId) {
            SpotifyService.createGenerator()
                .then(() => SpotifyService.authenticateAsGuest())
                .then(() => SpotifyService.getPlaylist(playlistId, userId))
                .then(playlist => {
                    this.playlist = playlist;
                    this.tracks = this.getTracks();
                    return { userId: userId, playlist: this.playlist };
                })
                .then(data => this.setPlaylistUrls(data))
                .catch(err => {
                    console.log(err);
                    this.goToHome();
                });
        },

        generateFinalPlaylist() {
            SpotifyService.getPlaylist(this.characterPlaylistId, appConfig.spotifyUser)
                .then(playlist => {
                    this.playlist = playlist;
                    return SpotifyService.isAuthenticated() ? this.getUserTracks() : [];
                })
                .then(userTracks => {
                    let playlistTracks = this.getTracks();
                    this.tracks = !userTracks || !userTracks.length ? playlistTracks 
                        : UtilService.shuffleArray(playlistTracks.concat(userTracks)).splice(0, 20);
                    return this.generatePlaylistUrls();
                })
                .then(data => this.setPlaylistUrls(data))
                .catch((e) => {
                    console.log(e);
                    this.goToHome();
                });
        },
        goToHome() {
            this.$router.push({ name: "home" });
        },
        getTracks() {
            let tracks = this.playlist.tracks.items.slice();
            return tracks.reduce((arr, track) => arr.concat(track.track), []).filter(track => !!track.preview_url);
        },
        getUserTracks() {
            return SpotifyService.getUserInfo()
                .then(([user, topGenres]) => {
                    let playlistTrackIds = UtilService.shuffleArray(this.getTracks())
                        .reduce((arr, track) => arr.concat(track.id), [])
                        .splice(0, 5);
                    return SpotifyService.generateFromSeeds({
                        genres: topGenres.toString(),
                        tracks: playlistTrackIds.splice(0,3)
                    });
                })
                .then(recomendedTracks => recomendedTracks.tracks.filter(track => !!track.preview_url))
                .then(recomendedTracks => UtilService.shuffleArray(recomendedTracks).splice(0, 10))
                .catch((e) => console.log(e));
        },
        generatePlaylistUrls() {
            return SpotifyService.isAuthenticated() ? SpotifyService.generatePlaylist(this.tracks, this.playlist.name)
                : Promise.resolve().then(() => ({
                        userId: appConfig.spotifyUser,
                        playlist: this.playlist
                    })
                );
        },
        setPlaylistUrls(data) {
            let playlistId = SpotifyService.isAuthenticated() ? data.playlist.id : '';
            this.shareFacebookUrl = appConfig.facebook_share_url.replace( "{url}", `${encodeURIComponent(window.location.href)}/${playlistId}`);
            this.shareTwitterUrl = appConfig.twitter_share_url.replace( "{url}", `${encodeURIComponent(window.location.href)}/${playlistId}`);
            this.openSpotifyUrl = appConfig.playlistsURL[this.characterPlaylist];
        },
        setActiveTrack(trackId){
            this.selectedTrackId = trackId;
        }
    }
};
</script>
